module.exports = __webpack_public_path__ + "static/media/codeall.a1ca76c0.jpg";